import { render } from "./SuperAdminModal.vue?vue&type=template&id=d8b034a4&scoped=true"
import script from "./SuperAdminModal.vue?vue&type=script&lang=js"
export * from "./SuperAdminModal.vue?vue&type=script&lang=js"

import "./SuperAdminModal.vue?vue&type=style&index=0&id=d8b034a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8b034a4"]])

export default __exports__